import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _9d69672e = () => interopDefault(import('..\\..\\..\\client\\pages\\Announcement.vue' /* webpackChunkName: "pages/Announcement" */))
const _e471a19a = () => interopDefault(import('..\\..\\..\\client\\pages\\Care.vue' /* webpackChunkName: "pages/Care" */))
const _bdf325c6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Consensus\\index.vue' /* webpackChunkName: "pages/Consensus/index" */))
const _2c21f2fa = () => interopDefault(import('..\\..\\..\\client\\pages\\DailyMarket.vue' /* webpackChunkName: "pages/DailyMarket" */))
const _52512014 = () => interopDefault(import('..\\..\\..\\client\\pages\\error.vue' /* webpackChunkName: "pages/error" */))
const _24de3f98 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_groups.vue' /* webpackChunkName: "pages/IR_groups" */))
const _48d0f1e7 = () => interopDefault(import('..\\..\\..\\client\\pages\\Issuccess.vue' /* webpackChunkName: "pages/Issuccess" */))
const _113fd3eb = () => interopDefault(import('..\\..\\..\\client\\pages\\Login\\index.vue' /* webpackChunkName: "pages/Login/index" */))
const _9b2a4462 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNewsFlash.vue' /* webpackChunkName: "pages/MarketNewsFlash" */))
const _a7efc970 = () => interopDefault(import('..\\..\\..\\client\\pages\\MobileStockPaper\\index.vue' /* webpackChunkName: "pages/MobileStockPaper/index" */))
const _79a5ca72 = () => interopDefault(import('..\\..\\..\\client\\pages\\pdfviewer.vue' /* webpackChunkName: "pages/pdfviewer" */))
const _7afe0654 = () => interopDefault(import('..\\..\\..\\client\\pages\\Policy.vue' /* webpackChunkName: "pages/Policy" */))
const _a027ace2 = () => interopDefault(import('..\\..\\..\\client\\pages\\PolicyYouth.vue' /* webpackChunkName: "pages/PolicyYouth" */))
const _1f906b6c = () => interopDefault(import('..\\..\\..\\client\\pages\\Principle.vue' /* webpackChunkName: "pages/Principle" */))
const _08770971 = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\index.vue' /* webpackChunkName: "pages/Promotion/index" */))
const _090337c6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Renewal.vue' /* webpackChunkName: "pages/Renewal" */))
const _a0b82a98 = () => interopDefault(import('..\\..\\..\\client\\pages\\ServiceUse.vue' /* webpackChunkName: "pages/ServiceUse" */))
const _7213494c = () => interopDefault(import('..\\..\\..\\client\\pages\\SignUp.vue' /* webpackChunkName: "pages/SignUp" */))
const _1cb7d1ea = () => interopDefault(import('..\\..\\..\\client\\pages\\StockItem\\index.vue' /* webpackChunkName: "pages/StockItem/index" */))
const _21833afc = () => interopDefault(import('..\\..\\..\\client\\pages\\template.vue' /* webpackChunkName: "pages/template" */))
const _59e0918b = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\index.vue' /* webpackChunkName: "pages/Theme/index" */))
const _cf1bbfa8 = () => interopDefault(import('..\\..\\..\\client\\pages\\Ticker.vue' /* webpackChunkName: "pages/Ticker" */))
const _db2edd1a = () => interopDefault(import('..\\..\\..\\client\\pages\\TodayWorld.vue' /* webpackChunkName: "pages/TodayWorld" */))
const _3dff5aa5 = () => interopDefault(import('..\\..\\..\\client\\pages\\Verification\\index.vue' /* webpackChunkName: "pages/Verification/index" */))
const _6353e2a0 = () => interopDefault(import('..\\..\\..\\client\\pages\\Common\\Process\\index.vue' /* webpackChunkName: "pages/Common/Process/index" */))
const _db7ccc46 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\100MBuySellRanking\\index.vue' /* webpackChunkName: "pages/Company/100MBuySellRanking/index" */))
const _3c3e8df3 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\CreditRatioRanking\\index.vue' /* webpackChunkName: "pages/Company/CreditRatioRanking/index" */))
const _1d5f2ca1 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\DailyShareChange\\index.vue' /* webpackChunkName: "pages/Company/DailyShareChange/index" */))
const _18a4bafd = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\DailyTreasuryStock\\index.vue' /* webpackChunkName: "pages/Company/DailyTreasuryStock/index" */))
const _4b0f00aa = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Disclosure\\index.vue' /* webpackChunkName: "pages/Company/Disclosure/index" */))
const _2381f8cc = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Features\\index.vue' /* webpackChunkName: "pages/Company/Features/index" */))
const _6b9998aa = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ForeignBuySellRanking\\index.vue' /* webpackChunkName: "pages/Company/ForeignBuySellRanking/index" */))
const _52207ef6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ForeignInstBuySellRanking\\index.vue' /* webpackChunkName: "pages/Company/ForeignInstBuySellRanking/index" */))
const _37a21abc = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ForeignInstContinueRanking\\index.vue' /* webpackChunkName: "pages/Company/ForeignInstContinueRanking/index" */))
const _4f2fa828 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\JumpSlumpReason\\index.vue' /* webpackChunkName: "pages/Company/JumpSlumpReason/index" */))
const _7990a8af = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\LoanTransaction\\index.vue' /* webpackChunkName: "pages/Company/LoanTransaction/index" */))
const _79d280a5 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\MarketAction\\index.vue' /* webpackChunkName: "pages/Company/MarketAction/index" */))
const _3c375a05 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\MiddleFeatures\\index.vue' /* webpackChunkName: "pages/Company/MiddleFeatures/index" */))
const _42f07015 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\OvertimeUnusual\\index.vue' /* webpackChunkName: "pages/Company/OvertimeUnusual/index" */))
const _fb3e772c = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\QuoteUnusual\\index.vue' /* webpackChunkName: "pages/Company/QuoteUnusual/index" */))
const _476c50bf = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\RecentIssue\\index.vue' /* webpackChunkName: "pages/Company/RecentIssue/index" */))
const _02ae163f = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\RiseDropRateRanking\\index.vue' /* webpackChunkName: "pages/Company/RiseDropRateRanking/index" */))
const _dc497fca = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ShortSellingRanking\\index.vue' /* webpackChunkName: "pages/Company/ShortSellingRanking/index" */))
const _45132064 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\StockTreasury\\index.vue' /* webpackChunkName: "pages/Company/StockTreasury/index" */))
const _73b2bcf8 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\TechnicalAnalysis\\index.vue' /* webpackChunkName: "pages/Company/TechnicalAnalysis/index" */))
const _9b5292fc = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\TodayIssues\\index.vue' /* webpackChunkName: "pages/Company/TodayIssues/index" */))
const _0a7340d2 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\TodayPopularSearch\\index.vue' /* webpackChunkName: "pages/Company/TodayPopularSearch/index" */))
const _305a3544 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\VI\\index.vue' /* webpackChunkName: "pages/Company/VI/index" */))
const _d1caa562 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\VolumeJump\\index.vue' /* webpackChunkName: "pages/Company/VolumeJump/index" */))
const _d8e42d6c = () => interopDefault(import('..\\..\\..\\client\\pages\\CustomerCenter\\Ad\\index.vue' /* webpackChunkName: "pages/CustomerCenter/Ad/index" */))
const _31bfbc16 = () => interopDefault(import('..\\..\\..\\client\\pages\\CustomerCenter\\Notice\\index.vue' /* webpackChunkName: "pages/CustomerCenter/Notice/index" */))
const _758a9094 = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\All.vue' /* webpackChunkName: "pages/EventNews/All" */))
const _6c9ecdd5 = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\Month.vue' /* webpackChunkName: "pages/EventNews/Month" */))
const _48ed18df = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\MonthSample.vue' /* webpackChunkName: "pages/EventNews/MonthSample" */))
const _5473742f = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\Week.vue' /* webpackChunkName: "pages/EventNews/Week" */))
const _1dc50ff8 = () => interopDefault(import('..\\..\\..\\client\\pages\\EventNews\\Year.vue' /* webpackChunkName: "pages/EventNews/Year" */))
const _fe38fb36 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\DataService\\index.vue' /* webpackChunkName: "pages/IR_B2B/DataService/index" */))
const _6df7f8f4 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\FinancialNews\\index.vue' /* webpackChunkName: "pages/IR_B2B/FinancialNews/index" */))
const _7370bddf = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\FlashService\\index.vue' /* webpackChunkName: "pages/IR_B2B/FlashService/index" */))
const _70c50b03 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\HistoryService\\index.vue' /* webpackChunkName: "pages/IR_B2B/HistoryService/index" */))
const _2a7ba90a = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\IR\\index.vue' /* webpackChunkName: "pages/IR_B2B/IR/index" */))
const _3b30a0de = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\IRCompanies\\index.vue' /* webpackChunkName: "pages/IR_B2B/IRCompanies/index" */))
const _477bfcf7 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\MarketService\\index.vue' /* webpackChunkName: "pages/IR_B2B/MarketService/index" */))
const _6cb09ddc = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\ScheduleService\\index.vue' /* webpackChunkName: "pages/IR_B2B/ScheduleService/index" */))
const _932cabbe = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\ServiceIntroduction\\index.vue' /* webpackChunkName: "pages/IR_B2B/ServiceIntroduction/index" */))
const _78ac4110 = () => interopDefault(import('..\\..\\..\\client\\pages\\IR_B2B\\ThemeService\\index.vue' /* webpackChunkName: "pages/IR_B2B/ThemeService/index" */))
const _0b9cc618 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Bond.vue' /* webpackChunkName: "pages/MarketNews/Bond" */))
const _145d7e76 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\China.vue' /* webpackChunkName: "pages/MarketNews/China" */))
const _30f85182 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\ClosingMarketNews\\index.vue' /* webpackChunkName: "pages/MarketNews/ClosingMarketNews/index" */))
const _a76c9186 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\CrudeOilPrice.vue' /* webpackChunkName: "pages/MarketNews/CrudeOilPrice" */))
const _ddf991a2 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\DailyNewsBriefing\\index.vue' /* webpackChunkName: "pages/MarketNews/DailyNewsBriefing/index" */))
const _3b9df774 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\ExchangeRate_ProductsTrend\\index.vue' /* webpackChunkName: "pages/MarketNews/ExchangeRate_ProductsTrend/index" */))
const _affb2914 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\ForeignExchange.vue' /* webpackChunkName: "pages/MarketNews/ForeignExchange" */))
const _9f586c22 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Futures.vue' /* webpackChunkName: "pages/MarketNews/Futures" */))
const _b02fc4b6 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Japan.vue' /* webpackChunkName: "pages/MarketNews/Japan" */))
const _61fe4714 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\KOSDAQ.vue' /* webpackChunkName: "pages/MarketNews/KOSDAQ" */))
const _5d923332 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\KOSPI.vue' /* webpackChunkName: "pages/MarketNews/KOSPI" */))
const _7f4dcff6 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\MajorCompaniesFluctuationRate\\index.vue' /* webpackChunkName: "pages/MarketNews/MajorCompaniesFluctuationRate/index" */))
const _38084b68 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\MajorCountriesIndex\\index.vue' /* webpackChunkName: "pages/MarketNews/MajorCountriesIndex/index" */))
const _9056a15e = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\NewYorkBond.vue' /* webpackChunkName: "pages/MarketNews/NewYorkBond" */))
const _1c689597 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\NewYorkClosing.vue' /* webpackChunkName: "pages/MarketNews/NewYorkClosing" */))
const _6c40a7b1 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\NewYorkExchange.vue' /* webpackChunkName: "pages/MarketNews/NewYorkExchange" */))
const _06393033 = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Semicon.vue' /* webpackChunkName: "pages/MarketNews/Semicon" */))
const _615b240a = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\SOX.vue' /* webpackChunkName: "pages/MarketNews/SOX" */))
const _fc5de98e = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\Taiwan.vue' /* webpackChunkName: "pages/MarketNews/Taiwan" */))
const _5d376a6c = () => interopDefault(import('..\\..\\..\\client\\pages\\MarketNews\\TodaySummary\\index.vue' /* webpackChunkName: "pages/MarketNews/TodaySummary/index" */))
const _a0445146 = () => interopDefault(import('..\\..\\..\\client\\pages\\MyPage\\MemberInfo\\index.vue' /* webpackChunkName: "pages/MyPage/MemberInfo/index" */))
const _344c49c6 = () => interopDefault(import('..\\..\\..\\client\\pages\\MyPage\\PayResponse\\index.vue' /* webpackChunkName: "pages/MyPage/PayResponse/index" */))
const _6ec08795 = () => interopDefault(import('..\\..\\..\\client\\pages\\MyPage\\ThemeAsk\\index.vue' /* webpackChunkName: "pages/MyPage/ThemeAsk/index" */))
const _0aea7962 = () => interopDefault(import('..\\..\\..\\client\\pages\\newsType\\htmlLoad\\index.vue' /* webpackChunkName: "pages/newsType/htmlLoad/index" */))
const _b3c9db56 = () => interopDefault(import('..\\..\\..\\client\\pages\\newsType\\list\\index.vue' /* webpackChunkName: "pages/newsType/list/index" */))
const _721851ca = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\Error\\index.vue' /* webpackChunkName: "pages/Promotion/Error/index" */))
const _89d67608 = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\ManageIntro\\index.vue' /* webpackChunkName: "pages/Promotion/ManageIntro/index" */))
const _3bd224ac = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\ManageSignIn\\index.vue' /* webpackChunkName: "pages/Promotion/ManageSignIn/index" */))
const _1f9e8674 = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\ManageSignUp\\index.vue' /* webpackChunkName: "pages/Promotion/ManageSignUp/index" */))
const _3d217420 = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\SubscribeComplete\\index.vue' /* webpackChunkName: "pages/Promotion/SubscribeComplete/index" */))
const _27c2739a = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\SubscribeError\\index.vue' /* webpackChunkName: "pages/Promotion/SubscribeError/index" */))
const _cb9fb020 = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\SubscriberComplete\\index.vue' /* webpackChunkName: "pages/Promotion/SubscriberComplete/index" */))
const _ae6e5f14 = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\SubscribeRegister\\index.vue' /* webpackChunkName: "pages/Promotion/SubscribeRegister/index" */))
const _05d78446 = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\SubscriberRegister\\index.vue' /* webpackChunkName: "pages/Promotion/SubscriberRegister/index" */))
const _44c7d6be = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\SubscriberRenew\\index.vue' /* webpackChunkName: "pages/Promotion/SubscriberRenew/index" */))
const _3c2bd625 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\DividendRateCompanyRanking.vue' /* webpackChunkName: "pages/Research/DividendRateCompanyRanking" */))
const _43e838f6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\GrowthEstimateCompanyRanking.vue' /* webpackChunkName: "pages/Research/GrowthEstimateCompanyRanking" */))
const _3e3dafb9 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\GrowthEstimateThemeRanking.vue' /* webpackChunkName: "pages/Research/GrowthEstimateThemeRanking" */))
const _5d272f8d = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\InfoStockInsight.vue' /* webpackChunkName: "pages/Research/InfoStockInsight" */))
const _19904e84 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\MainEarning.vue' /* webpackChunkName: "pages/Research/MainEarning" */))
const _5b30c47e = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\MarketDividendRateCompanyRanking.vue' /* webpackChunkName: "pages/Research/MarketDividendRateCompanyRanking" */))
const _523ea765 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\PER_PBR_EPS_ROE_CompanyRanking.vue' /* webpackChunkName: "pages/Research/PER_PBR_EPS_ROE_CompanyRanking" */))
const _54742db0 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\ResultDeviationCompanyRanking.vue' /* webpackChunkName: "pages/Research/ResultDeviationCompanyRanking" */))
const _4ba06978 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmInvestmentOpinion.vue' /* webpackChunkName: "pages/Research/StockFirmInvestmentOpinion" */))
const _2929ed5d = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\index.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/index" */))
const _7723dd8a = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmReport.vue' /* webpackChunkName: "pages/Research/StockFirmReport" */))
const _b481834c = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmStrongBuying.vue' /* webpackChunkName: "pages/Research/StockFirmStrongBuying" */))
const _af16064e = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\DailyFeaturedTheme.vue' /* webpackChunkName: "pages/Theme/DailyFeaturedTheme" */))
const _6d9d0b18 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeBriefing\\index.vue' /* webpackChunkName: "pages/Theme/ThemeBriefing/index" */))
const _f3b1c2bc = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\index.vue' /* webpackChunkName: "pages/Theme/ThemeDB/index" */))
const _2c7bb6a6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeFluctuations\\index.vue' /* webpackChunkName: "pages/Theme/ThemeFluctuations/index" */))
const _746ea442 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeIndex\\index.vue' /* webpackChunkName: "pages/Theme/ThemeIndex/index" */))
const _757b8f10 = () => interopDefault(import('..\\..\\..\\client\\pages\\Analysis\\StockInfo\\Chart.vue' /* webpackChunkName: "pages/Analysis/StockInfo/Chart" */))
const _cfcf4348 = () => interopDefault(import('..\\..\\..\\client\\pages\\Analysis\\StockInfo\\Outline.vue' /* webpackChunkName: "pages/Analysis/StockInfo/Outline" */))
const _5d7cd1af = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\Earning\\index.vue' /* webpackChunkName: "pages/Company/Analysis/Earning/index" */))
const _52f28edd = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockHistory\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockHistory/index" */))
const _2bce6456 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockHistorySearch\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockHistorySearch/index" */))
const _05a9a456 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockInfo\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockInfo/index" */))
const _5efa29b0 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockNameChanged\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockNameChanged/index" */))
const _ac830464 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Analysis\\StockThemeChart\\index.vue' /* webpackChunkName: "pages/Company/Analysis/StockThemeChart/index" */))
const _1f4c5876 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\Features\\Table.vue' /* webpackChunkName: "pages/Company/Features/Table" */))
const _73fdc4f1 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\OvertimeUnusual\\Table.vue' /* webpackChunkName: "pages/Company/OvertimeUnusual/Table" */))
const _7a2ed612 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ShortSellingRanking\\Table.vue' /* webpackChunkName: "pages/Company/ShortSellingRanking/Table" */))
const _c7176f9c = () => interopDefault(import('..\\..\\..\\client\\pages\\newsType\\htmlLoad\\test.vue' /* webpackChunkName: "pages/newsType/htmlLoad/test" */))
const _37b4050c = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\Subscribe\\3n3VNJLV0y\\index.vue' /* webpackChunkName: "pages/Promotion/Subscribe/3n3VNJLV0y/index" */))
const _dbd02f2e = () => interopDefault(import('..\\..\\..\\client\\pages\\Promotion\\Subscribe\\3n3VNJLV0yRegister\\index.vue' /* webpackChunkName: "pages/Promotion/Subscribe/3n3VNJLV0yRegister/index" */))
const _24f05a48 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\DailyRecommend.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/DailyRecommend" */))
const _0b2f4ce7 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\ExcludeRecommend.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/ExcludeRecommend" */))
const _6b65065f = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\PortfolioEarningRateRanking.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/PortfolioEarningRateRanking" */))
const _18eab466 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\RecommendByStockFirm.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/RecommendByStockFirm" */))
const _015869a6 = () => interopDefault(import('..\\..\\..\\client\\pages\\Research\\StockFirmRecommend\\StockEarningRateRanking.vue' /* webpackChunkName: "pages/Research/StockFirmRecommend/StockEarningRateRanking" */))
const _1f9d7e98 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\ThemeAll.vue' /* webpackChunkName: "pages/Theme/ThemeDB/ThemeAll" */))
const _c8b9173c = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\ThemeAllAllowed\\index.vue' /* webpackChunkName: "pages/Theme/ThemeDB/ThemeAllAllowed/index" */))
const _8158823e = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\ThemeAllAllowed\\ThemeDBAllowed.vue' /* webpackChunkName: "pages/Theme/ThemeDB/ThemeAllAllowed/ThemeDBAllowed" */))
const _60014561 = () => interopDefault(import('..\\..\\..\\client\\pages\\CustomerCenter\\Ad\\Detail\\_id.vue' /* webpackChunkName: "pages/CustomerCenter/Ad/Detail/_id" */))
const _1e59dc68 = () => interopDefault(import('..\\..\\..\\client\\pages\\CustomerCenter\\Notice\\Detail\\_id.vue' /* webpackChunkName: "pages/CustomerCenter/Notice/Detail/_id" */))
const _f8f48c8a = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\ThemeAllAllowed\\_ThemeDetail.vue' /* webpackChunkName: "pages/Theme/ThemeDB/ThemeAllAllowed/_ThemeDetail" */))
const _6ebd358a = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\ForeignInstContinueRanking\\_id.vue' /* webpackChunkName: "pages/Company/ForeignInstContinueRanking/_id" */))
const _e14cd6e0 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\JumpSlumpReason\\_id.vue' /* webpackChunkName: "pages/Company/JumpSlumpReason/_id" */))
const _2f6e19ad = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\MiddleFeatures\\_id.vue' /* webpackChunkName: "pages/Company/MiddleFeatures/_id" */))
const _b20ac732 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\RiseDropRateRanking\\_id.vue' /* webpackChunkName: "pages/Company/RiseDropRateRanking/_id" */))
const _0a142868 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\StockTreasury\\_id.vue' /* webpackChunkName: "pages/Company/StockTreasury/_id" */))
const _f1919628 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\TechnicalAnalysis\\_id.vue' /* webpackChunkName: "pages/Company/TechnicalAnalysis/_id" */))
const _de7c9112 = () => interopDefault(import('..\\..\\..\\client\\pages\\Company\\VolumeJump\\_id.vue' /* webpackChunkName: "pages/Company/VolumeJump/_id" */))
const _608bf10a = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeDB\\_ThemeDetail.vue' /* webpackChunkName: "pages/Theme/ThemeDB/_ThemeDetail" */))
const _ea092356 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeFluctuations\\_id.vue' /* webpackChunkName: "pages/Theme/ThemeFluctuations/_id" */))
const _04cb84a9 = () => interopDefault(import('..\\..\\..\\client\\pages\\Theme\\ThemeIndex\\_ThemeIndexDetail.vue' /* webpackChunkName: "pages/Theme/ThemeIndex/_ThemeIndexDetail" */))
const _b01760a0 = () => interopDefault(import('..\\..\\..\\client\\pages\\MobileStockPaper\\_id.vue' /* webpackChunkName: "pages/MobileStockPaper/_id" */))
const _36fb89ca = () => interopDefault(import('..\\..\\..\\client\\pages\\newsType\\_id.vue' /* webpackChunkName: "pages/newsType/_id" */))
const _d9dd5c80 = () => interopDefault(import('..\\..\\..\\client\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/Announcement",
    component: _9d69672e,
    name: "Announcement"
  }, {
    path: "/Care",
    component: _e471a19a,
    name: "Care"
  }, {
    path: "/Consensus",
    component: _bdf325c6,
    name: "Consensus"
  }, {
    path: "/DailyMarket",
    component: _2c21f2fa,
    name: "DailyMarket"
  }, {
    path: "/error",
    component: _52512014,
    name: "error"
  }, {
    path: "/IR_groups",
    component: _24de3f98,
    name: "IR_groups"
  }, {
    path: "/Issuccess",
    component: _48d0f1e7,
    name: "Issuccess"
  }, {
    path: "/Login",
    component: _113fd3eb,
    name: "Login"
  }, {
    path: "/MarketNewsFlash",
    component: _9b2a4462,
    name: "MarketNewsFlash"
  }, {
    path: "/MobileStockPaper",
    component: _a7efc970,
    name: "MobileStockPaper"
  }, {
    path: "/pdfviewer",
    component: _79a5ca72,
    name: "pdfviewer"
  }, {
    path: "/Policy",
    component: _7afe0654,
    name: "Policy"
  }, {
    path: "/PolicyYouth",
    component: _a027ace2,
    name: "PolicyYouth"
  }, {
    path: "/Principle",
    component: _1f906b6c,
    name: "Principle"
  }, {
    path: "/Promotion",
    component: _08770971,
    name: "Promotion"
  }, {
    path: "/Renewal",
    component: _090337c6,
    name: "Renewal"
  }, {
    path: "/ServiceUse",
    component: _a0b82a98,
    name: "ServiceUse"
  }, {
    path: "/SignUp",
    component: _7213494c,
    name: "SignUp"
  }, {
    path: "/StockItem",
    component: _1cb7d1ea,
    name: "StockItem"
  }, {
    path: "/template",
    component: _21833afc,
    name: "template"
  }, {
    path: "/Theme",
    component: _59e0918b,
    name: "Theme"
  }, {
    path: "/Ticker",
    component: _cf1bbfa8,
    name: "Ticker"
  }, {
    path: "/TodayWorld",
    component: _db2edd1a,
    name: "TodayWorld"
  }, {
    path: "/Verification",
    component: _3dff5aa5,
    name: "Verification"
  }, {
    path: "/Common/Process",
    component: _6353e2a0,
    name: "Common-Process"
  }, {
    path: "/Company/100MBuySellRanking",
    component: _db7ccc46,
    name: "Company-100MBuySellRanking"
  }, {
    path: "/Company/CreditRatioRanking",
    component: _3c3e8df3,
    name: "Company-CreditRatioRanking"
  }, {
    path: "/Company/DailyShareChange",
    component: _1d5f2ca1,
    name: "Company-DailyShareChange"
  }, {
    path: "/Company/DailyTreasuryStock",
    component: _18a4bafd,
    name: "Company-DailyTreasuryStock"
  }, {
    path: "/Company/Disclosure",
    component: _4b0f00aa,
    name: "Company-Disclosure"
  }, {
    path: "/Company/Features",
    component: _2381f8cc,
    name: "Company-Features"
  }, {
    path: "/Company/ForeignBuySellRanking",
    component: _6b9998aa,
    name: "Company-ForeignBuySellRanking"
  }, {
    path: "/Company/ForeignInstBuySellRanking",
    component: _52207ef6,
    name: "Company-ForeignInstBuySellRanking"
  }, {
    path: "/Company/ForeignInstContinueRanking",
    component: _37a21abc,
    name: "Company-ForeignInstContinueRanking"
  }, {
    path: "/Company/JumpSlumpReason",
    component: _4f2fa828,
    name: "Company-JumpSlumpReason"
  }, {
    path: "/Company/LoanTransaction",
    component: _7990a8af,
    name: "Company-LoanTransaction"
  }, {
    path: "/Company/MarketAction",
    component: _79d280a5,
    name: "Company-MarketAction"
  }, {
    path: "/Company/MiddleFeatures",
    component: _3c375a05,
    name: "Company-MiddleFeatures"
  }, {
    path: "/Company/OvertimeUnusual",
    component: _42f07015,
    name: "Company-OvertimeUnusual"
  }, {
    path: "/Company/QuoteUnusual",
    component: _fb3e772c,
    name: "Company-QuoteUnusual"
  }, {
    path: "/Company/RecentIssue",
    component: _476c50bf,
    name: "Company-RecentIssue"
  }, {
    path: "/Company/RiseDropRateRanking",
    component: _02ae163f,
    name: "Company-RiseDropRateRanking"
  }, {
    path: "/Company/ShortSellingRanking",
    component: _dc497fca,
    name: "Company-ShortSellingRanking"
  }, {
    path: "/Company/StockTreasury",
    component: _45132064,
    name: "Company-StockTreasury"
  }, {
    path: "/Company/TechnicalAnalysis",
    component: _73b2bcf8,
    name: "Company-TechnicalAnalysis"
  }, {
    path: "/Company/TodayIssues",
    component: _9b5292fc,
    name: "Company-TodayIssues"
  }, {
    path: "/Company/TodayPopularSearch",
    component: _0a7340d2,
    name: "Company-TodayPopularSearch"
  }, {
    path: "/Company/VI",
    component: _305a3544,
    name: "Company-VI"
  }, {
    path: "/Company/VolumeJump",
    component: _d1caa562,
    name: "Company-VolumeJump"
  }, {
    path: "/CustomerCenter/Ad",
    component: _d8e42d6c,
    name: "CustomerCenter-Ad"
  }, {
    path: "/CustomerCenter/Notice",
    component: _31bfbc16,
    name: "CustomerCenter-Notice"
  }, {
    path: "/EventNews/All",
    component: _758a9094,
    name: "EventNews-All"
  }, {
    path: "/EventNews/Month",
    component: _6c9ecdd5,
    name: "EventNews-Month"
  }, {
    path: "/EventNews/MonthSample",
    component: _48ed18df,
    name: "EventNews-MonthSample"
  }, {
    path: "/EventNews/Week",
    component: _5473742f,
    name: "EventNews-Week"
  }, {
    path: "/EventNews/Year",
    component: _1dc50ff8,
    name: "EventNews-Year"
  }, {
    path: "/IR_B2B/DataService",
    component: _fe38fb36,
    name: "IR_B2B-DataService"
  }, {
    path: "/IR_B2B/FinancialNews",
    component: _6df7f8f4,
    name: "IR_B2B-FinancialNews"
  }, {
    path: "/IR_B2B/FlashService",
    component: _7370bddf,
    name: "IR_B2B-FlashService"
  }, {
    path: "/IR_B2B/HistoryService",
    component: _70c50b03,
    name: "IR_B2B-HistoryService"
  }, {
    path: "/IR_B2B/IR",
    component: _2a7ba90a,
    name: "IR_B2B-IR"
  }, {
    path: "/IR_B2B/IRCompanies",
    component: _3b30a0de,
    name: "IR_B2B-IRCompanies"
  }, {
    path: "/IR_B2B/MarketService",
    component: _477bfcf7,
    name: "IR_B2B-MarketService"
  }, {
    path: "/IR_B2B/ScheduleService",
    component: _6cb09ddc,
    name: "IR_B2B-ScheduleService"
  }, {
    path: "/IR_B2B/ServiceIntroduction",
    component: _932cabbe,
    name: "IR_B2B-ServiceIntroduction"
  }, {
    path: "/IR_B2B/ThemeService",
    component: _78ac4110,
    name: "IR_B2B-ThemeService"
  }, {
    path: "/MarketNews/Bond",
    component: _0b9cc618,
    name: "MarketNews-Bond"
  }, {
    path: "/MarketNews/China",
    component: _145d7e76,
    name: "MarketNews-China"
  }, {
    path: "/MarketNews/ClosingMarketNews",
    component: _30f85182,
    name: "MarketNews-ClosingMarketNews"
  }, {
    path: "/MarketNews/CrudeOilPrice",
    component: _a76c9186,
    name: "MarketNews-CrudeOilPrice"
  }, {
    path: "/MarketNews/DailyNewsBriefing",
    component: _ddf991a2,
    name: "MarketNews-DailyNewsBriefing"
  }, {
    path: "/MarketNews/ExchangeRate_ProductsTrend",
    component: _3b9df774,
    name: "MarketNews-ExchangeRate_ProductsTrend"
  }, {
    path: "/MarketNews/ForeignExchange",
    component: _affb2914,
    name: "MarketNews-ForeignExchange"
  }, {
    path: "/MarketNews/Futures",
    component: _9f586c22,
    name: "MarketNews-Futures"
  }, {
    path: "/MarketNews/Japan",
    component: _b02fc4b6,
    name: "MarketNews-Japan"
  }, {
    path: "/MarketNews/KOSDAQ",
    component: _61fe4714,
    name: "MarketNews-KOSDAQ"
  }, {
    path: "/MarketNews/KOSPI",
    component: _5d923332,
    name: "MarketNews-KOSPI"
  }, {
    path: "/MarketNews/MajorCompaniesFluctuationRate",
    component: _7f4dcff6,
    name: "MarketNews-MajorCompaniesFluctuationRate"
  }, {
    path: "/MarketNews/MajorCountriesIndex",
    component: _38084b68,
    name: "MarketNews-MajorCountriesIndex"
  }, {
    path: "/MarketNews/NewYorkBond",
    component: _9056a15e,
    name: "MarketNews-NewYorkBond"
  }, {
    path: "/MarketNews/NewYorkClosing",
    component: _1c689597,
    name: "MarketNews-NewYorkClosing"
  }, {
    path: "/MarketNews/NewYorkExchange",
    component: _6c40a7b1,
    name: "MarketNews-NewYorkExchange"
  }, {
    path: "/MarketNews/Semicon",
    component: _06393033,
    name: "MarketNews-Semicon"
  }, {
    path: "/MarketNews/SOX",
    component: _615b240a,
    name: "MarketNews-SOX"
  }, {
    path: "/MarketNews/Taiwan",
    component: _fc5de98e,
    name: "MarketNews-Taiwan"
  }, {
    path: "/MarketNews/TodaySummary",
    component: _5d376a6c,
    name: "MarketNews-TodaySummary"
  }, {
    path: "/MyPage/MemberInfo",
    component: _a0445146,
    name: "MyPage-MemberInfo"
  }, {
    path: "/MyPage/PayResponse",
    component: _344c49c6,
    name: "MyPage-PayResponse"
  }, {
    path: "/MyPage/ThemeAsk",
    component: _6ec08795,
    name: "MyPage-ThemeAsk"
  }, {
    path: "/newsType/htmlLoad",
    component: _0aea7962,
    name: "newsType-htmlLoad"
  }, {
    path: "/newsType/list",
    component: _b3c9db56,
    name: "newsType-list"
  }, {
    path: "/Promotion/Error",
    component: _721851ca,
    name: "Promotion-Error"
  }, {
    path: "/Promotion/ManageIntro",
    component: _89d67608,
    name: "Promotion-ManageIntro"
  }, {
    path: "/Promotion/ManageSignIn",
    component: _3bd224ac,
    name: "Promotion-ManageSignIn"
  }, {
    path: "/Promotion/ManageSignUp",
    component: _1f9e8674,
    name: "Promotion-ManageSignUp"
  }, {
    path: "/Promotion/SubscribeComplete",
    component: _3d217420,
    name: "Promotion-SubscribeComplete"
  }, {
    path: "/Promotion/SubscribeError",
    component: _27c2739a,
    name: "Promotion-SubscribeError"
  }, {
    path: "/Promotion/SubscriberComplete",
    component: _cb9fb020,
    name: "Promotion-SubscriberComplete"
  }, {
    path: "/Promotion/SubscribeRegister",
    component: _ae6e5f14,
    name: "Promotion-SubscribeRegister"
  }, {
    path: "/Promotion/SubscriberRegister",
    component: _05d78446,
    name: "Promotion-SubscriberRegister"
  }, {
    path: "/Promotion/SubscriberRenew",
    component: _44c7d6be,
    name: "Promotion-SubscriberRenew"
  }, {
    path: "/Research/DividendRateCompanyRanking",
    component: _3c2bd625,
    name: "Research-DividendRateCompanyRanking"
  }, {
    path: "/Research/GrowthEstimateCompanyRanking",
    component: _43e838f6,
    name: "Research-GrowthEstimateCompanyRanking"
  }, {
    path: "/Research/GrowthEstimateThemeRanking",
    component: _3e3dafb9,
    name: "Research-GrowthEstimateThemeRanking"
  }, {
    path: "/Research/InfoStockInsight",
    component: _5d272f8d,
    name: "Research-InfoStockInsight"
  }, {
    path: "/Research/MainEarning",
    component: _19904e84,
    name: "Research-MainEarning"
  }, {
    path: "/Research/MarketDividendRateCompanyRanking",
    component: _5b30c47e,
    name: "Research-MarketDividendRateCompanyRanking"
  }, {
    path: "/Research/PER_PBR_EPS_ROE_CompanyRanking",
    component: _523ea765,
    name: "Research-PER_PBR_EPS_ROE_CompanyRanking"
  }, {
    path: "/Research/ResultDeviationCompanyRanking",
    component: _54742db0,
    name: "Research-ResultDeviationCompanyRanking"
  }, {
    path: "/Research/StockFirmInvestmentOpinion",
    component: _4ba06978,
    name: "Research-StockFirmInvestmentOpinion"
  }, {
    path: "/Research/StockFirmRecommend",
    component: _2929ed5d,
    name: "Research-StockFirmRecommend"
  }, {
    path: "/Research/StockFirmReport",
    component: _7723dd8a,
    name: "Research-StockFirmReport"
  }, {
    path: "/Research/StockFirmStrongBuying",
    component: _b481834c,
    name: "Research-StockFirmStrongBuying"
  }, {
    path: "/Theme/DailyFeaturedTheme",
    component: _af16064e,
    name: "Theme-DailyFeaturedTheme"
  }, {
    path: "/Theme/ThemeBriefing",
    component: _6d9d0b18,
    name: "Theme-ThemeBriefing"
  }, {
    path: "/Theme/ThemeDB",
    component: _f3b1c2bc,
    name: "Theme-ThemeDB"
  }, {
    path: "/Theme/ThemeFluctuations",
    component: _2c7bb6a6,
    name: "Theme-ThemeFluctuations"
  }, {
    path: "/Theme/ThemeIndex",
    component: _746ea442,
    name: "Theme-ThemeIndex"
  }, {
    path: "/Analysis/StockInfo/Chart",
    component: _757b8f10,
    name: "Analysis-StockInfo-Chart"
  }, {
    path: "/Analysis/StockInfo/Outline",
    component: _cfcf4348,
    name: "Analysis-StockInfo-Outline"
  }, {
    path: "/Company/Analysis/Earning",
    component: _5d7cd1af,
    name: "Company-Analysis-Earning"
  }, {
    path: "/Company/Analysis/StockHistory",
    component: _52f28edd,
    name: "Company-Analysis-StockHistory"
  }, {
    path: "/Company/Analysis/StockHistorySearch",
    component: _2bce6456,
    name: "Company-Analysis-StockHistorySearch"
  }, {
    path: "/Company/Analysis/StockInfo",
    component: _05a9a456,
    name: "Company-Analysis-StockInfo"
  }, {
    path: "/Company/Analysis/StockNameChanged",
    component: _5efa29b0,
    name: "Company-Analysis-StockNameChanged"
  }, {
    path: "/Company/Analysis/StockThemeChart",
    component: _ac830464,
    name: "Company-Analysis-StockThemeChart"
  }, {
    path: "/Company/Features/Table",
    component: _1f4c5876,
    name: "Company-Features-Table"
  }, {
    path: "/Company/OvertimeUnusual/Table",
    component: _73fdc4f1,
    name: "Company-OvertimeUnusual-Table"
  }, {
    path: "/Company/ShortSellingRanking/Table",
    component: _7a2ed612,
    name: "Company-ShortSellingRanking-Table"
  }, {
    path: "/newsType/htmlLoad/test",
    component: _c7176f9c,
    name: "newsType-htmlLoad-test"
  }, {
    path: "/Promotion/Subscribe/3n3VNJLV0y",
    component: _37b4050c,
    name: "Promotion-Subscribe-3n3VNJLV0y"
  }, {
    path: "/Promotion/Subscribe/3n3VNJLV0yRegister",
    component: _dbd02f2e,
    name: "Promotion-Subscribe-3n3VNJLV0yRegister"
  }, {
    path: "/Research/StockFirmRecommend/DailyRecommend",
    component: _24f05a48,
    name: "Research-StockFirmRecommend-DailyRecommend"
  }, {
    path: "/Research/StockFirmRecommend/ExcludeRecommend",
    component: _0b2f4ce7,
    name: "Research-StockFirmRecommend-ExcludeRecommend"
  }, {
    path: "/Research/StockFirmRecommend/PortfolioEarningRateRanking",
    component: _6b65065f,
    name: "Research-StockFirmRecommend-PortfolioEarningRateRanking"
  }, {
    path: "/Research/StockFirmRecommend/RecommendByStockFirm",
    component: _18eab466,
    name: "Research-StockFirmRecommend-RecommendByStockFirm"
  }, {
    path: "/Research/StockFirmRecommend/StockEarningRateRanking",
    component: _015869a6,
    name: "Research-StockFirmRecommend-StockEarningRateRanking"
  }, {
    path: "/Theme/ThemeDB/ThemeAll",
    component: _1f9d7e98,
    name: "Theme-ThemeDB-ThemeAll"
  }, {
    path: "/Theme/ThemeDB/ThemeAllAllowed",
    component: _c8b9173c,
    name: "Theme-ThemeDB-ThemeAllAllowed"
  }, {
    path: "/Theme/ThemeDB/ThemeAllAllowed/ThemeDBAllowed",
    component: _8158823e,
    name: "Theme-ThemeDB-ThemeAllAllowed-ThemeDBAllowed"
  }, {
    path: "/CustomerCenter/Ad/Detail/:id?",
    component: _60014561,
    name: "CustomerCenter-Ad-Detail-id"
  }, {
    path: "/CustomerCenter/Notice/Detail/:id?",
    component: _1e59dc68,
    name: "CustomerCenter-Notice-Detail-id"
  }, {
    path: "/Theme/ThemeDB/ThemeAllAllowed/:ThemeDetail",
    component: _f8f48c8a,
    name: "Theme-ThemeDB-ThemeAllAllowed-ThemeDetail"
  }, {
    path: "/Company/ForeignInstContinueRanking/:id",
    component: _6ebd358a,
    name: "Company-ForeignInstContinueRanking-id"
  }, {
    path: "/Company/JumpSlumpReason/:id",
    component: _e14cd6e0,
    name: "Company-JumpSlumpReason-id"
  }, {
    path: "/Company/MiddleFeatures/:id",
    component: _2f6e19ad,
    name: "Company-MiddleFeatures-id"
  }, {
    path: "/Company/RiseDropRateRanking/:id",
    component: _b20ac732,
    name: "Company-RiseDropRateRanking-id"
  }, {
    path: "/Company/StockTreasury/:id",
    component: _0a142868,
    name: "Company-StockTreasury-id"
  }, {
    path: "/Company/TechnicalAnalysis/:id",
    component: _f1919628,
    name: "Company-TechnicalAnalysis-id"
  }, {
    path: "/Company/VolumeJump/:id",
    component: _de7c9112,
    name: "Company-VolumeJump-id"
  }, {
    path: "/Theme/ThemeDB/:ThemeDetail",
    component: _608bf10a,
    name: "Theme-ThemeDB-ThemeDetail"
  }, {
    path: "/Theme/ThemeFluctuations/:id",
    component: _ea092356,
    name: "Theme-ThemeFluctuations-id"
  }, {
    path: "/Theme/ThemeIndex/:ThemeIndexDetail",
    component: _04cb84a9,
    name: "Theme-ThemeIndex-ThemeIndexDetail"
  }, {
    path: "/MobileStockPaper/:id",
    component: _b01760a0,
    name: "MobileStockPaper-id"
  }, {
    path: "/newsType/:id?",
    component: _36fb89ca,
    name: "newsType-id"
  }, {
    path: "/",
    component: _d9dd5c80,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
